import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Alert } from '@mui/material';

export default function SnackMessage({ message, setMessage, duration = 5000 }) {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setMessage({ text: '', type: '' });
  };

  // Solo se despliega ante excepciones o errores
  const isErrorOrDanger = Boolean(
    message?.text && (
      message.type === 'error' ||
      message.type === 'danger' ||
      message.type === 'exception' ||
      message.isError
    )
  );

  return (
    <Snackbar
      open={isErrorOrDanger}
      autoHideDuration={message?.duration || duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity="error"
        variant="filled"
        sx={{
          width: '100%',
          minWidth: '320px',
          maxWidth: '650px',
          background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.96) 0%, rgba(153, 27, 27, 0.98) 100%)',
          color: '#ffffff',
          borderRadius: '12px',
          border: '1px solid rgba(254, 202, 202, 0.35)',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5), 0 0 20px rgba(239, 68, 68, 0.45)',
          fontWeight: 600,
          fontSize: '0.92rem',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          '& .MuiAlert-icon': {
            color: '#fff',
            fontSize: '1.4rem',
            alignItems: 'center',
          },
          '& .MuiAlert-action': {
            color: '#fff',
            paddingTop: 0,
            alignItems: 'center',
          },
          '& .MuiIconButton-root': {
            color: 'rgba(255, 255, 255, 0.85)',
            '&:hover': {
              color: '#ffffff',
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
            },
          },
        }}
      >
        {message?.text}
      </Alert>
    </Snackbar>
  );
}